import React from 'react';
import { useTranslation } from 'react-i18next';
import { Facebook, Instagram, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const links = [
    { label: t('nav.missionStatement'), to: '/mission-statement' },
    { label: t('nav.membership'), to: '/membership' },
    { label: t('nav.events'), to: '/events' },
    { label: t('nav.newsletter'), to: '/newsletter' },
  ];

  return (
    <footer className="bg-[#14233b] text-white">
      <div className="h-1 bg-[linear-gradient(90deg,#d95f75_0_33%,#f5f6f8_33%_66%,#2457a7_66%)]" />
      <div className="page-container py-14 sm:py-16">
        <div className="grid gap-10 lg:grid-cols-[1.3fr_0.7fr_0.9fr] lg:gap-16">
          <div>
            <div className="flex items-center gap-4">
              <img src="/LOGO.png" alt="JAJ Logo" className="h-16 w-16 rounded-full object-cover" />
              <div>
                <h2 className="text-lg font-extrabold">Japanese Association of Jacksonville</h2>
                <p className="font-japanese mt-1 text-sm text-[#f4b7c2]">ジャクソンビル日本人会</p>
              </div>
            </div>
            <p className="mt-6 max-w-xl text-sm leading-6 text-white/65">
              Promoting Japanese culture and heritage through community events, education, and friendship across Northeast Florida.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase text-[#f4b7c2]">Explore</h3>
            <div className="mt-5 grid grid-cols-2 gap-x-5 gap-y-3 lg:grid-cols-1">
              {links.map((link) => (
                <Link key={link.to} to={link.to} className="text-sm font-semibold text-white/75 transition hover:text-white">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase text-[#f4b7c2]">Connect</h3>
            <div className="mt-5 space-y-3 text-sm text-white/75">
              <a href="mailto:jaxjapanese@gmail.com" className="flex items-center gap-3 transition hover:text-white">
                <Mail className="h-4 w-4 text-[#f4b7c2]" />
                jaxjapanese@gmail.com
              </a>
              <p className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-[#f4b7c2]" />
                Jacksonville, Florida
              </p>
            </div>
            <div className="mt-6 flex gap-2">
              <a href="https://www.facebook.com/jaj.florida" target="_blank" rel="noopener noreferrer" className="flex h-10 w-10 items-center justify-center border border-white/15 text-white/75 transition hover:border-white/40 hover:text-white" aria-label="Facebook">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="https://www.instagram.com/japaneseassociation" target="_blank" rel="noopener noreferrer" className="flex h-10 w-10 items-center justify-center border border-white/15 text-white/75 transition hover:border-white/40 hover:text-white" aria-label="Instagram">
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 grid gap-4 border-t border-white/10 pt-7 text-xs leading-5 text-white/45 lg:grid-cols-[1fr_auto] lg:items-end">
          <p className="max-w-4xl">{t('footer.disclaimer')}</p>
          <p className="whitespace-nowrap">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
